/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { usePopper } from 'react-popper';
import ResizeObserver from 'resize-observer-polyfill';
import { Portal } from '../Portal';
import { theme } from '../../theme';
export const Backdrop = styled.div.withConfig({ displayName: "vui--Backdrop", componentId: "vui--d5k10p" }) `position:fixed;top:0;right:0;bottom:0;left:0;z-index:${({ zIndex }) => zIndex};`;
const PopoverWrapper = styled.div.withConfig({ displayName: "vui--PopoverWrapper", componentId: "vui--13ndjce" }) `z-index:${({ zIndex }) => zIndex + 1};`;
export const Popover = ({ children, className, anchorElement, rootElementRef, placement = 'bottom', onShouldClose, 
// FIXME: Added zIndex prop as a temporary solution for issues with nested overlays
// to be replaced with long term solution
zIndex = theme.layers.popup, }) => {
    // Set up PopperJS
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes, update } = usePopper(anchorElement, popperElement, { placement });
    // When content size is changed, force popper update
    useEffect(() => {
        if (!update || !popperElement)
            return;
        const resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(popperElement);
        return () => {
            resizeObserver.disconnect();
        };
    }, [update, popperElement]);
    // When window is resized, force popper update
    useEffect(() => {
        if (!update)
            return;
        window.addEventListener('resize', update);
        return () => {
            window.removeEventListener('resize', update);
        };
    }, [update]);
    return (React.createElement(Portal, { rootElementRef: rootElementRef },
        onShouldClose && React.createElement(Backdrop, { onClick: onShouldClose, zIndex: zIndex }),
        React.createElement(PopoverWrapper, Object.assign({ ref: setPopperElement, className: className, zIndex: zIndex, style: Object.assign({}, styles.popper) }, attributes.popper), children)));
};
//# sourceMappingURL=Popover.js.map